'use strict';

const angular = require('angular');

import {PROJECTS_STATES_CONFIG} from './projects.states';
import './projectSearchResultType';

module.exports = angular
  .module('spinnaker.projects', [
    PROJECTS_STATES_CONFIG,
  ]);



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/projects/projects.module.js